document.addEventListener('DOMContentLoaded', () => {
  const header = document.querySelector('[data-site-header]');
  const toggle = document.querySelector('[data-mobile-toggle]');
  const currentSearch = window.location.search;

  const applyDefaultCollectionSort = () => {
    if ((window.Shopify && window.Shopify.designMode) || !window.location.pathname.startsWith('/collections/')) return;

    const pathSegments = window.location.pathname.split('/').filter(Boolean);
    if (pathSegments.length < 2 || pathSegments[0] !== 'collections') return;
    if (pathSegments.length > 3) return;
    if (pathSegments.length === 2 && pathSegments[1] === '') return;

    const url = new URL(window.location.href);
    if (url.searchParams.has('sort_by')) return;

    url.searchParams.set('sort_by', 'best-selling');
    window.location.replace(url.pathname + '?' + url.searchParams.toString() + url.hash);
  };

  applyDefaultCollectionSort();

  const closeNav = () => {
    if (!header || !toggle) return;
    header.classList.remove('is-open');
    toggle.setAttribute('aria-expanded', 'false');
    document.body.classList.remove('nav-open');
  };

  if (header && toggle) {
    toggle.addEventListener('click', () => {
      const isOpen = header.classList.toggle('is-open');
      toggle.setAttribute('aria-expanded', String(isOpen));
      document.body.classList.toggle('nav-open', isOpen);
    });

    window.addEventListener('resize', () => {
      if (window.innerWidth >= 980) {
        closeNav();
      }
    });

    document.addEventListener('keydown', (event) => {
      if (event.key === 'Escape') {
        closeNav();
      }
    });
  }

  const preserveQueryForLink = (anchor) => {
    if (!anchor || !currentSearch || anchor.hasAttribute('data-no-preserve-query')) return;
    const rawHref = anchor.getAttribute('href');
    if (!rawHref || rawHref.startsWith('#') || rawHref.startsWith('mailto:') || rawHref.startsWith('tel:') || rawHref.startsWith('javascript:')) return;

    let target;
    try {
      target = new URL(anchor.href, window.location.origin);
    } catch (error) {
      return;
    }

    if (target.origin !== window.location.origin) return;
    if (target.search) return;

    target.search = currentSearch;
    anchor.href = target.pathname + target.search + target.hash;
  };

  if (currentSearch) {
    document.querySelectorAll('a[data-preserve-query], a[href^="/"]').forEach((anchor) => {
      preserveQueryForLink(anchor);
    });
  }

  document.addEventListener('click', (event) => {
    const anchor = event.target.closest('a');
    if (!anchor) return;
    preserveQueryForLink(anchor);

    if (header && header.classList.contains('is-open') && anchor.closest('#SiteNav')) {
      closeNav();
    }
  });


  document.querySelectorAll('[data-collection-jump]').forEach((select) => {
    select.addEventListener('change', () => {
      const value = select.value;
      if (!value) return;
      let nextHref = value;
      try {
        const target = new URL(value, window.location.origin);
        if (currentSearch && !target.search) {
          target.search = currentSearch;
        }
        nextHref = target.pathname + target.search + target.hash;
      } catch (error) {
        nextHref = value;
      }
      window.location.href = nextHref;
    });
  });

  const setSearchLoadingState = (form, { buttonText, statusText } = {}) => {
    if (!form || form.dataset.searchSubmitting === 'true') return;

    form.dataset.searchSubmitting = 'true';
    form.classList.add('is-search-submitting');
    form.setAttribute('aria-busy', 'true');

    const submitButton = form.querySelector('[data-search-submit-button]');
    const submitLabel = form.querySelector('[data-search-submit-label]');
    const feedback = form.querySelector('[data-search-submit-feedback]');

    if (submitButton) {
      submitButton.disabled = true;
      submitButton.classList.add('is-loading');
    }

    if (submitLabel) {
      submitLabel.textContent = buttonText || submitButton?.dataset.loadingLabel || 'Searching...';
    }

    if (feedback) {
      feedback.textContent = statusText || 'Searching the shop...';
      feedback.hidden = false;
      feedback.classList.remove('visually-hidden');
    }
  };

  document.querySelectorAll('[data-shop-search-form]').forEach((form) => {
    form.addEventListener('submit', (event) => {
      const queryInput = form.querySelector('[data-shop-search-query], input[name="q"]');
      const collectionSelect = form.querySelector('[data-shop-search-collection], [data-search-collection-filter]');
      const query = queryInput ? queryInput.value.trim() : '';
      const selectedOption = collectionSelect && collectionSelect.selectedOptions.length ? collectionSelect.selectedOptions[0] : null;
      const collectionUrl = selectedOption ? selectedOption.dataset.url : '';

      if (!query) {
        if (collectionUrl) {
          event.preventDefault();
          setSearchLoadingState(form, {
            buttonText: 'Opening...',
            statusText: 'Opening that collection...'
          });

          const target = new URL(collectionUrl, window.location.origin);
          const previewParams = new URLSearchParams(window.location.search);
          previewParams.forEach((value, key) => {
            if (!target.searchParams.has(key)) target.searchParams.set(key, value);
          });
          window.location.href = target.pathname + target.search + target.hash;
          return;
        }

        event.preventDefault();
        if (queryInput) queryInput.focus();
        return;
      }

      setSearchLoadingState(form, {
        buttonText: 'Searching...',
        statusText: 'Searching the shop. Results are on the way...'
      });
    });
  });


  document.querySelectorAll('[data-collection-browser]').forEach((browser) => {
    const input = browser.querySelector('[data-collection-search-input]');
    const status = browser.querySelector('[data-collection-status]');
    const grid = document.querySelector('[data-collection-grid]');
    const cards = grid ? Array.from(grid.querySelectorAll('[data-collection-card]')) : [];

    if (!input || !cards.length) return;

    const updateCollectionBrowser = () => {
      const term = input.value.trim().toLowerCase();
      let visibleCount = 0;

      cards.forEach((card) => {
        const haystack = (card.dataset.searchText || '').toLowerCase();
        const matches = !term || haystack.includes(term);
        card.classList.toggle('is-hidden-by-filter', !matches);
        card.toggleAttribute('hidden', !matches);
        if (matches) visibleCount += 1;
      });

      if (status) {
        if (term) {
          status.textContent = visibleCount === 1 ? '1 collection matches.' : `${visibleCount} collections match.`;
        } else {
          status.textContent = visibleCount === 1 ? 'Showing 1 collection.' : `Showing ${visibleCount} collections.`;
        }
      }
    };

    input.addEventListener('input', updateCollectionBrowser);
    updateCollectionBrowser();
  });

  document.querySelectorAll('[data-product-browser]').forEach((browser) => {
    const searchInput = browser.querySelector('[data-product-search-input]');
    const availabilityFilter = browser.querySelector('[data-product-availability-filter]');
    const tagFilter = browser.querySelector('[data-product-tag-filter]');
    const status = browser.querySelector('[data-product-browser-status]');
    const grid = browser.parentElement ? browser.parentElement.querySelector('[data-product-grid]') : null;
    const empty = browser.parentElement ? browser.parentElement.querySelector('[data-product-browser-empty]') : null;
    const pagination = browser.parentElement ? browser.parentElement.querySelector('.pagination') : null;
    const cards = grid ? Array.from(grid.querySelectorAll('[data-product-card]')) : [];

    if (!cards.length) return;

    const updateProductBrowser = () => {
      const term = searchInput ? searchInput.value.trim().toLowerCase() : '';
      const availability = availabilityFilter ? availabilityFilter.value : '';
      const tag = tagFilter ? tagFilter.value.trim().toLowerCase() : '';
      let visibleCount = 0;

      cards.forEach((card) => {
        const haystack = (card.dataset.searchText || '').toLowerCase();
        const tags = (card.dataset.tags || '').toLowerCase().split('|').filter(Boolean);
        const isAvailable = String(card.dataset.available) === 'true';

        const matchesTerm = !term || haystack.includes(term);
        const matchesAvailability = !availability || (availability === 'in-stock' ? isAvailable : !isAvailable);
        const matchesTag = !tag || tags.includes(tag);
        const matches = matchesTerm && matchesAvailability && matchesTag;

        card.classList.toggle('is-hidden-by-filter', !matches);
        card.toggleAttribute('hidden', !matches);
        if (matches) visibleCount += 1;
      });

      if (status) {
        const parts = [];
        if (term) parts.push(`matching “${term}”`);
        if (tag) parts.push(`tagged ${tag}`);
        if (availability === 'in-stock') parts.push('in stock');
        if (availability === 'sold-out') parts.push('sold out');
        const qualifier = parts.length ? ` ${parts.join(', ')}` : '';
        status.textContent = visibleCount === 1 ? `Showing 1 item${qualifier}.` : `Showing ${visibleCount} items${qualifier}.`;
      }

      if (empty) {
        empty.classList.toggle('visually-hidden', visibleCount !== 0);
      }
      if (pagination) {
        pagination.classList.toggle('visually-hidden', visibleCount === 0);
      }
    };

    if (searchInput) searchInput.addEventListener('input', updateProductBrowser);
    if (availabilityFilter) availabilityFilter.addEventListener('change', updateProductBrowser);
    if (tagFilter) tagFilter.addEventListener('change', updateProductBrowser);
    updateProductBrowser();
  });


  document.querySelectorAll('[data-search-results-browser]').forEach((browser) => {
    const collectionFilter = document.querySelector('[data-search-collection-filter]');
    const status = browser.querySelector('[data-search-results-status]');
    const grid = browser.parentElement ? browser.parentElement.querySelector('[data-search-results-grid]') : null;
    const empty = browser.parentElement ? browser.parentElement.querySelector('[data-search-results-empty]') : null;
    const pagination = browser.parentElement ? browser.parentElement.querySelector('.pagination') : null;
    const cards = grid ? Array.from(grid.querySelectorAll('[data-product-card]')) : [];

    if (!cards.length) return;

    const params = new URLSearchParams(window.location.search);
    if (collectionFilter && params.get('filter_collection')) {
      collectionFilter.value = params.get('filter_collection');
    }
    const updateSearchResults = () => {
      const selectedCollection = collectionFilter ? collectionFilter.value.trim().toLowerCase() : '';
      let visibleCount = 0;

      cards.forEach((card) => {
        const collectionHandles = (card.dataset.collections || '').toLowerCase().split('|').filter(Boolean);
        const matchesCollection = !selectedCollection || collectionHandles.includes(selectedCollection);
        const matches = matchesCollection;

        card.classList.toggle('is-hidden-by-filter', !matches);
        card.toggleAttribute('hidden', !matches);
        if (matches) visibleCount += 1;
      });

      if (status) {
        const parts = [];
        if (selectedCollection) parts.push('in that collection');
        const qualifier = parts.length ? ` ${parts.join(', ')}` : '';
        status.textContent = visibleCount === 1 ? `Showing 1 result${qualifier}.` : `Showing ${visibleCount} results${qualifier}.`;
      }

      if (empty) {
        empty.classList.toggle('visually-hidden', visibleCount !== 0);
      }
      if (pagination) {
        pagination.classList.toggle('visually-hidden', visibleCount === 0);
      }

      if (window.history && window.history.replaceState) {
        const nextParams = new URLSearchParams(window.location.search);
        if (selectedCollection) nextParams.set('filter_collection', selectedCollection); else nextParams.delete('filter_collection');
        nextParams.delete('filter_availability');
        nextParams.delete('availability');
        const nextSearch = nextParams.toString();
        const nextUrl = window.location.pathname + (nextSearch ? `?${nextSearch}` : '') + window.location.hash;
        window.history.replaceState({}, document.title, nextUrl);
      }
    };

    if (collectionFilter) collectionFilter.addEventListener('change', updateSearchResults);
    updateSearchResults();
  });

  document.querySelectorAll('[data-product-page]').forEach((productPage) => {
    const mainImage = productPage.querySelector('[data-product-gallery] .product-media-image, [data-product-gallery] img');
    const thumbButtons = Array.from(productPage.querySelectorAll('[data-product-thumbs] [data-image-id]'));
    const prevButton = productPage.querySelector('[data-product-prev]');
    const nextButton = productPage.querySelector('[data-product-next]');
    const variantSelect = productPage.querySelector('[data-product-variant-select]');
    const variantsScript = productPage.querySelector('[data-product-variants]');
    const priceNode = productPage.querySelector('[data-product-price]');
    const comparePriceNode = productPage.querySelector('[data-product-compare-price]');
    const saleBadge = productPage.querySelector('[data-product-sale-badge]');
    const stockBadge = productPage.querySelector('[data-product-stock-badge]');
    const submitButton = productPage.querySelector('[data-product-submit]');
    const submitLabel = productPage.querySelector('[data-product-submit-label]');
    const productForm = productPage.querySelector('[data-product-form]');
    const stickyPriceNode = productPage.querySelector('[data-product-sticky-price]');
    const stickySubmitButton = productPage.querySelector('[data-product-sticky-submit]');
    const stickySubmitLabel = productPage.querySelector('[data-product-sticky-submit-label]');

    if (stickySubmitButton && productForm) {
      stickySubmitButton.addEventListener('click', () => {
        if (stickySubmitButton.disabled) return;

        if (typeof productForm.requestSubmit === 'function') {
          productForm.requestSubmit(submitButton || undefined);
          return;
        }

        if (submitButton) {
          submitButton.click();
        } else {
          productForm.submit();
        }
      });
    }

    if (!mainImage) return;

    let currentIndex = Math.max(thumbButtons.findIndex((button) => button.classList.contains('is-active')), 0);
    let variants = [];

    if (variantsScript) {
      try {
        variants = JSON.parse(variantsScript.textContent);
      } catch (error) {
        variants = [];
      }
    }

    const setActiveThumb = (index) => {
      if (!thumbButtons.length) return;
      const safeIndex = ((index % thumbButtons.length) + thumbButtons.length) % thumbButtons.length;
      const button = thumbButtons[safeIndex];
      if (!button) return;
      currentIndex = safeIndex;
      thumbButtons.forEach((thumb) => thumb.classList.remove('is-active'));
      button.classList.add('is-active');
      mainImage.src = button.dataset.imageSrc;
      if (button.dataset.imageSrcset) {
        mainImage.srcset = button.dataset.imageSrcset;
      } else {
        mainImage.removeAttribute('srcset');
      }
      if (button.dataset.imageSizes) {
        mainImage.sizes = button.dataset.imageSizes;
      }
      mainImage.alt = button.dataset.imageAlt || mainImage.alt || '';
      button.scrollIntoView({ block: 'nearest', inline: 'center', behavior: 'smooth' });
    };

    thumbButtons.forEach((button, index) => {
      button.addEventListener('click', () => setActiveThumb(index));
    });

    if (prevButton) {
      prevButton.addEventListener('click', () => setActiveThumb(currentIndex - 1));
    }

    if (nextButton) {
      nextButton.addEventListener('click', () => setActiveThumb(currentIndex + 1));
    }

    if (variantSelect && variants.length) {
      const updateVariantState = () => {
        const selectedId = variantSelect.value;
        const selectedVariant = variants.find((variant) => String(variant.id) === String(selectedId));
        if (!selectedVariant) return;

        if (priceNode) {
          priceNode.textContent = selectedVariant.price || priceNode.textContent;
        }

        if (stickyPriceNode) {
          stickyPriceNode.textContent = selectedVariant.price || stickyPriceNode.textContent;
        }

        if (comparePriceNode) {
          comparePriceNode.textContent = selectedVariant.compare_at_price || '';
          comparePriceNode.classList.toggle('visually-hidden', !selectedVariant.has_compare_at_price);
        }

        if (saleBadge) {
          saleBadge.classList.toggle('visually-hidden', !selectedVariant.has_compare_at_price);
        }

        if (stockBadge) {
          stockBadge.textContent = selectedVariant.available ? 'In stock' : 'Sold out';
          stockBadge.classList.toggle('badge--soldout', !selectedVariant.available);
        }

        if (submitButton) {
          submitButton.disabled = !selectedVariant.available;
        }

        if (stickySubmitButton) {
          stickySubmitButton.disabled = !selectedVariant.available;
        }

        if (submitLabel) {
          submitLabel.textContent = selectedVariant.available ? 'Add to cart' : 'Sold out';
        }

        if (stickySubmitLabel) {
          stickySubmitLabel.textContent = selectedVariant.available ? 'Add to cart' : 'Sold out';
        }

        if (selectedVariant.featured_image_id && thumbButtons.length) {
          const nextIndex = thumbButtons.findIndex((button) => String(button.dataset.imageId) === String(selectedVariant.featured_image_id));
          if (nextIndex >= 0) {
            setActiveThumb(nextIndex);
          }
        }
      };

      variantSelect.addEventListener('change', updateVariantState);
      updateVariantState();
    }
  });

  document.querySelectorAll('.custom-order-form').forEach((form) => {
    const submitButton = form.querySelector('[data-submit-button]');
    const submitLabel = submitButton ? submitButton.querySelector('.button-label') : null;
    const feedback = form.querySelector('[data-form-feedback]');
    const successMessage = form.querySelector('[data-form-success]');

    if (successMessage) {
      const url = new URL(window.location.href);
      let didChangeUrl = false;
      ['contact_posted', 'form_type', 'utf8'].forEach((key) => {
        if (url.searchParams.has(key)) {
          url.searchParams.delete(key);
          didChangeUrl = true;
        }
      });
      if (didChangeUrl && window.history && window.history.replaceState) {
        const cleanSearch = url.searchParams.toString();
        const cleanUrl = url.pathname + (cleanSearch ? `?${cleanSearch}` : '') + url.hash;
        window.history.replaceState({}, document.title, cleanUrl);
      }

      window.requestAnimationFrame(() => {
        successMessage.focus({ preventScroll: false });
      });
      return;
    }

    form.addEventListener('submit', () => {
      if (form.dataset.submitting === 'true') return;
      form.dataset.submitting = 'true';
      form.classList.add('is-submitting');
      form.setAttribute('aria-busy', 'true');

      if (feedback) {
        feedback.innerHTML = '<div class="notice-banner notice-banner--info" role="status">Sending your request. Please stay on this page for confirmation.</div>';
      }

      if (submitButton) {
        submitButton.disabled = true;
        submitButton.classList.add('is-loading');
      }

      if (submitLabel && submitButton) {
        submitLabel.textContent = submitButton.dataset.loadingLabel || 'Sending request...';
      }
    });
  });

});
